/* Format a statistic value the same way client-side count-up does. */
/* Returns '-' for null/undefined/NaN so the SSR fallback is obvious. */
const formatStatistic = function (value, name) {
	const number = Number(value);
	if (value === null || value === undefined || Number.isNaN(number)) {
		return '-';
	}

	switch (name) {
		case 'averageResponseTime':
			return new Date(1000 * number).toISOString().slice(11, 19);
		default:
			return number.toLocaleString('en');
	}
};

export default formatStatistic;
